import { render } from "./Navbar.vue?vue&type=template&id=c742cf34&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=c742cf34&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c742cf34"

export default script